import _taggedTemplateLiteral from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import { Typography } from '@finam/web-ui-kit';
import { ExclamationMarkCircleFilled } from '@finam/web-ui-kit/Icons/ExclamationMark';
import styled from 'styled-components';
export var Root = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  border-radius: 6px;\n  padding: 8px;\n  margin-bottom: 24px;\n  background-color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.fill.negative.overlay8;
});
export var IconWrap = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  padding-left: 10px;\n  padding-right: 18px;\n"])));
export var ErrorIcon = styled(ExclamationMarkCircleFilled)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.label.negative;
});
export var ErrorText = styled(Typography).attrs({
  variant: 'body14',
  weight: 'medium'
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.label.negative;
});
export var Description = styled(Typography).attrs({
  variant: 'caption12'
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.label.negative;
});